import { useCallback, useRef } from 'react';

export const useResizeEnd = (timeout: number, callback: () => void) => {
    const resizeEnd = useRef(0);

    return useCallback(() => {
        resizeEnd.current = new Date().getTime();
        setTimeout(() => {
            if (new Date().getTime() - resizeEnd.current > timeout-30) {
                callback && callback();
            }
        }, timeout);
    }, [callback,timeout]);
};
